import { Component, OnInit } from '@angular/core';
import { FormsModule,FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { UserService } from '../services/userService';
import { Router } from '@angular/router';
//import { AuthService } from '../services/auth.service';
import { User } from '../models/User';
@Component({
  selector: 'app-accept',
  standalone: true,
  imports: [FormsModule],
  templateUrl: './accept.component.html',
  styleUrl: './accept.component.css'
})
export class AcceptComponent implements OnInit {
  //Error: boolean;
  Message: string ="";
  User: User = new User();
  isAccepted: boolean = false;

  constructor(
    private userService: UserService,
    private router: Router
  ) {

  }

  ngOnInit() {
    this.userService.getCurrentUser().subscribe((data) => {
      this.User = data;
      console.log(this.User);
    });
  }

  isSubmitDisabled(): boolean {
    return !this.isAccepted;
  }

  submit() {
    this.User.HasAcceptedTandC = this.isAccepted;
    this.userService.acceptTerms(this.User.Id).subscribe(data => {
      console.log(data);
      this.router.navigate(['']);
    })
  }
}
